import Swal from "sweetalert2";

export function checkResultResponse(res, contentSuccess, contentFailed) {
  if (res !== undefined && res.data !== undefined && res.data.resultCode === undefined && res.data.result !== undefined) {
    return checkResponse(res, contentSuccess, contentFailed)
  }
  else {
    if (res !== undefined && (res.status === undefined || res.status === 200) && res.data !== undefined && res.data.resultCode !== undefined && res.data.resultCode === 0) {
      if (contentSuccess != null) alertResultResponse(res, contentSuccess, contentFailed)
      return true
    }
    else {
      alertResultResponse(res, contentSuccess, contentFailed)
      return false
    }
  }
}

export function alertResultResponse(res, contentSuccess, contentFailed) {
  if (res !== undefined) {
    if (res.status !== undefined && res.status === 200) {
      alertResultObjectResponse(res.data, contentSuccess, contentFailed)
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'İşlemde hata oluştu.',
        html: (contentFailed ? contentFailed + '<br />' : '') + 'HTTP durum kodu: ' + res.status.toString() + '\nHTTP durum açıklaması: ' + res.statusText,
        confirmButtonText: "Tamam"
      })
    }
  }
  else {
    Swal.fire({
      icon: 'error',
      title: 'İşlemde hata oluştu.',
      html: (contentFailed ? contentFailed + '<br />' : '') + 'Yanıt boş',
      confirmButtonText: "Tamam"
    })
  }
}

export function checkResultObjectResponse(result, contentSuccess, contentFailed) {
  if (result !== undefined && result.resultCode !== undefined && result.resultCode === 0) {
    if (contentSuccess != null) alertResultObjectResponse(result, contentSuccess, contentFailed)
    return true
  }
  else {
    alertResultObjectResponse(result, contentSuccess, contentFailed)
    return false
  }
}

export function alertResultObjectResponse(result, contentSuccess, contentFailed) {
  if (result !== undefined) {
    if (result.resultCode !== undefined) {    
      if (result.resultCode === 0) {
        if (contentSuccess !== null) {
          Swal.fire({
            icon: 'success',
            title: (contentSuccess ? contentSuccess : 'İşlem başarılı.'),
            confirmButtonText: "Tamam"
          })
        }
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'İşlemde hata oluştu.',
          html: (contentFailed ? contentFailed + '<br />' : '') + '<b>Hata kodu</b>: ' + result.resultCode.toString() + (result.resultUserFriendlyDescription ? '<br /><b>Hata açıklaması</b>: ' + result.resultUserFriendlyDescription : (result.resultDescription ? '<br /><b>Hata açıklaması</b>: ' + result.resultDescription : '')),
          confirmButtonText: "Tamam"
        })
      }
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'İşlemde hata oluştu.',
        html: (contentFailed ? contentFailed + '<br />' : '') + 'Hata kodu: Boş',
        confirmButtonText: "Tamam"
      })
    }
  }
  else {
    Swal.fire({
      icon: 'error',
      title: 'İşlemde hata oluştu.',
      html: (contentFailed ? contentFailed + '<br />' : '') + 'Yanıt boş',
      confirmButtonText: "Tamam"
    })
  }
}

export function checkResponse(res, contentSuccess, contentFailed) {
  if (res !== undefined && res.data !== undefined && res.data.result === undefined && res.data.resultCode !== undefined) {
    return checkResultResponse(res, contentSuccess, contentFailed)
  }
  else {
    if (res !== undefined && (res.status === undefined || res.status === 200) && res.data !== undefined && res.data.result !== undefined && res.data.result.resultCode !== undefined && res.data.result.resultCode === 0) {
      if (contentSuccess != null) alertResponse(res, contentSuccess, contentFailed)
      return true
    }
    else {
      alertResponse(res, contentSuccess, contentFailed)
      return false
    }
  }
}

export function alertResponse(res, contentSuccess, contentFailed) {
  if (res !== undefined) {
    if (res.status !== undefined && res.status === 200) {
      if (res.data !== undefined) {
        alertResultObjectResponse(res.data.result, contentSuccess, contentFailed)
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'İşlemde hata oluştu.',
          html: (contentFailed ? contentFailed + '<br />' : '') + 'Dönen yanıtta veri boş.',
          confirmButtonText: "Tamam"
        })
      }
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'İşlemde hata oluştu.',
        html: (contentFailed ? contentFailed + '<br />' : '') + 'HTTP durum kodu: ' + (res.status ? res.status.toString() : 'Boş') + '\nHTTP durum açıklaması: ' + (res.statusText ? res.statusText : 'Boş'),
        confirmButtonText: "Tamam"
      })
    }
  }
  else {
    Swal.fire({
      icon: 'error',
      title: 'İşlemde hata oluştu.',
      html: (contentFailed ? contentFailed + '<br />' : '') + 'Yanıt: Boş',
      confirmButtonText: "Tamam"
    })
  }
}

export function alertResponseError(error, contentFailed) {
  Swal.fire({
    icon: 'error',
    title: 'İşlemde hata oluştu.',
    html: getResponseErrorHtml(error, contentFailed),
    confirmButtonText: "Tamam"
  })
}

export function getResponseErrorText(error, contentFailed) {
  return (contentFailed ? contentFailed + ' > ' : '') + (error && error.message ? error.message : 'Bilinmeyen hata')
}

export function getResponseErrorHtml(error, contentFailed) {
  return (contentFailed ? contentFailed + '<br />' : '') + 'Hata mesajı: ' + (error && error.message ? error.message + (error.message === 'Network Error' ? '<br />Lütfen Internet bağlantınızı kontrol ediniz.' : '') : 'Bilinmeyen hata')
    + (error && error.response && error.response.data && error.response.data.message ? '<br />Hata yanıt mesajı: ' + error.response.data.message : '')
}

export function alertErrorText(errorTitle, errorHtml) {
  Swal.fire({
    icon: 'error',
    title: (errorTitle ? errorTitle : 'İşlemde hata oluştu.'),
    html: (errorHtml ? errorHtml : null),
    confirmButtonText: "Tamam", 
  })
}


export function alertWarningText(errorTitle, errorHtml) {
  Swal.fire({
    icon: 'warning',
    title: (errorTitle ? errorTitle : 'İşlemde hata oluştu.'),
    html: (errorHtml ? errorHtml : null),
    confirmButtonText: "Tamam"
  })
}

export function alertSuccessText(errorTitle, errorHtml) {
  Swal.fire({
    icon: 'success',
    title: (errorTitle ? errorTitle : 'İşlemde hata oluştu.'),
    html: (errorHtml ? errorHtml : null),
    confirmButtonText: "Tamam"
  })
}